import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm" }, "Su factura sera enviada al siguiente correo electronico:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: true,
    visible: _ctx.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
    header: "Factura Electronica",
    style: { width: '28rem' }
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Omitir",
        class: "p-button-text",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
      }),
      _createVNode(_component_Button, {
        label: "Enviar factura",
        loading: _ctx.sending,
        disabled: !_ctx.localEmail,
        onClick: _ctx.handleSend
      }, null, 8, ["loading", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_InputText, {
        modelValue: _ctx.localEmail,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localEmail) = $event)),
        class: "tw-w-full tw-mt-2",
        placeholder: "Email"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["visible"]))
}